import React, {Component} from "react";

class PlaidRevalidateButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csrfToken: props.csrfToken,
            publicToken: props.publicToken,
            plaidItemId: props.plaidItemId,
            activate: props.activate
        };
    }

    render() {
        // there is a jQuery handler at index.html that binds to onClick for this button
        const classString = this.state.activate ? "ui button card-bottom fluid plaid-link-button" : "ui disabled button card-bottom fluid plaid-link-button";
        return (
            <div className={classString} data-csrf_token={this.state.csrfToken} data-public_token={this.state.publicToken} data-plaid_item_id={this.state.plaidItemId}>
                <i className="redo icon"></i> Revalidate
            </div>
        )
    }
}

export default PlaidRevalidateButton;